export enum ExportEntityType {
  PROJECT = 'project',
  BOM = 'bom',
}
